// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-footer[data-v-5cd44e4c]{max-width:90em;margin:0 auto}.v-footer ul li a[data-v-5cd44e4c]{color:#fff}.v-footer ul li a[data-v-5cd44e4c]:hover{color:#66b4ef}", ""]);
// Exports
module.exports = exports;
